export { default as PlaceholderHighlight } from './PlaceholderHighlight';
export {
  createPlaceholderSuggestion,
  createSuggestionRenderer,
} from './PlaceholderSuggestion';
export type { PlaceholderItem, SuggestionListRef } from './PlaceholderSuggestion';
